// orgVisitModalTabs.ts
// Named tab indices for OrganizationVisitModalDetailsTabs. Numeric values are the
// historical MUI Tab `value`s — DO NOT renumber (preserves behavior).
export enum OrgVisitModalTab {
  Complaints = 1, // Dolegliwości (visit.description + booking attachments)
  AiNote = 2, // (unused — read-only note tab removed; kept to preserve numbering)
  Forms = 3, // Formularze
  PatientNotes = 4, // Notatki dla pacjenta
  InternalNotes = 5, // Notatki wewnętrzne
  Course = 6, // Przebieg wizyty
  Medications = 7, // Leki
  Treatments = 8, // Zabiegi
  Documents = 9, // Dokumenty
  Reminders = 10, // Przypomnienia
  Transcription = 11, // Transkrypcja
  Assistant = 12, // Asystent Vetsi
}
